import { pointApi } from '@/api';
import { API_RETURN_CODE } from '@/utils/variables';

const actions = {};

/**
 * Point 정보
 *  @param {*} param0
 */
actions.getPointInfo = ({ commit }) => {
  return pointApi.getPointInfo().then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      commit('SET_POINTINFO', res.data.data);
    }

    return res.data.code;
  });
};

/**
 * Point 내역
 *  @param {*} param0
 *  @param {Object} val
 */
actions.getPointHistory = ({ commit }, val) => {
  return pointApi.getPointHistory(val).then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      commit('SET_POINTHISTORY', res.data.data);
    }

    return res.data.code;
  });
};

/**
 * Point 내역 현재 페이지
 *  @param {*} param0
 *  @param {Number} val
 */
actions.setPointListPageNo = ({ commit }, val) => {
  commit('SET_POINTLISTPAGENO', val);
};

/**
 * Point 내역 시작일
 *  @param {*} param0
 *  @param {String} val
 */
actions.setPointListStartDate = ({ commit }, val) => {
  commit('SET_POINTLISTSTARTDATE', val);
};

/**
 * Point 내역 종료일
 *  @param {*} param0
 *  @param {String} val
 */
actions.setPointListEndDate = ({ commit }, val) => {
  commit('SET_POINTLISTENDDATE', val);
};

/**
 * Point 내역 상태
 *  @param {*} param0
 *  @param {Number} val
 */
actions.setPointListStatus = ({ commit }, val) => {
  commit('SET_POINTLISTSTATUS', val);
};

export default {
  ...actions,
};
